import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { UserModel } from 'src/app/services/user-model';
import { UserService, UserType } from 'src/app/services/user.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {

  private unsubscribe: Subscription[] = [];
  userPermissions: any = this.uService.userPermissions;

  @Input() products: any;
  user$: Observable<UserType>;

  constructor(
    private router: Router,
    public userModel: UserModel,
    private userService: UserService,
    private uService: UtilsService
  ) {
    this.user$ = this.userService.currentUserSubject.asObservable();
  }

  ngOnInit() {
    // console.log(this.menu);
  }

  irInicio() {
    this.router.navigateByUrl('/');
  }

  goToPage(url: any) {
    console.log(url);
    this.router.navigateByUrl('/'+url);
  }

  ngOnDestroy(): void {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

}
